import React from 'react'
import classes from '../../Table.module.scss'

export const FeatureList = ({ children }: { children: React.ReactNode }) => (
  <div role='rowgroup' className={classes.body}>
    {children}
  </div>
)
